// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import type { PolicyDetail } from '../types/procedures';

export interface PolicyValidationErrors {
  title?: string;
  policyNumber?: string;
  classification?: string;
  policyDomain?: string;
  scope?: string;
  enforcementPoint?: string;
  decisionSummary?: string;
  package?: string;
}

/**
 * Single source of truth for the policy guided form's required fields —
 * shared by `PolicyForm` (inline `invalid`/`invalidText` per field) and
 * `CreatePolicyPage` (disabling Submit), so the two can't drift apart. Git
 * file paths (`files.*`) are intentionally not required — a draft can be
 * written before its `.rego` file exists.
 */
export function validatePolicy(policy: PolicyDetail): PolicyValidationErrors {
  const errors: PolicyValidationErrors = {};

  if (!policy.title.trim()) errors.title = 'Title is required.';
  if (!policy.policyNumber.trim()) errors.policyNumber = 'Policy # is required.';
  if (!policy.classification.trim()) errors.classification = 'Classification is required.';
  if (!policy.policyDomain.trim()) errors.policyDomain = 'Policy domain is required.';
  if (!policy.scope.trim()) errors.scope = 'Scope is required.';
  if (!policy.enforcementPoint.trim()) errors.enforcementPoint = 'Enforcement point is required.';
  if (!policy.decisionSummary.trim()) {
    errors.decisionSummary = 'Decision summary is required.';
  }
  if (!policy.package.trim()) errors.package = 'Package is required.';

  return errors;
}

export function isPolicyValid(policy: PolicyDetail): boolean {
  return Object.keys(validatePolicy(policy)).length === 0;
}
